module.exports = __webpack_public_path__ + "static/img/recognition2.7c69c9d3.png";